interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "NPR";
};

const NPR: Currency = Object.freeze({
  "displayName": "Nepalese Rupee",
  "numericCode": 524,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "NPR",
  "symbol": "रू"
});

export { NPR };
